import React from 'react';
import type { ProductStat } from '../../types/product';
type ProductStatsProps = {
  stats: ProductStat[];
};
export function ProductStats({
  stats
}: ProductStatsProps) {
  return <section className="w-full border-b border-canvas-line bg-white py-14" aria-label="Key numbers" data-id="element-1213" data-mp="22tidflfq6q2j">
      <dl className="mx-auto grid max-w-shell grid-cols-1 gap-8 px-6 sm:grid-cols-3 sm:gap-0 sm:divide-x sm:divide-canvas-line" data-id="element-1214" data-mp="1xuynzb1xaw5f">
        {stats.map(stat => <div key={stat.label} className="sm:px-10 sm:first:pl-0 sm:last:pr-0" data-id="element-1215" data-mp="2bsn7ofk97x8w">
            <dt className="sr-only" data-id="element-1216" data-mp="26uu6k0xt5tfh">{stat.label}</dt>
            <dd data-id="element-1217" data-mp="2lk01vdtiyzi3">
              <p className="display text-[36px] font-semibold text-brand sm:text-[40px]" data-id="element-1218" data-mp="2lkjb86540fki">{stat.value}</p>
              <p className="mt-2 max-w-[280px] text-[15px] leading-[1.5] text-ink-muted" data-id="element-1219" data-mp="2gm7ztqz61x06">{stat.label}</p>
            </dd>
          </div>)}
      </dl>
    </section>;
}